import React from 'react'
import { ModernInput } from '../ui'
import { formatPlate } from '../../utils/formatters'

interface PlateInputProps {
 value: string
 onChange: (value: string) => void
 error?: string
 placeholder?: string
 disabled?: boolean
}

export const PlateInput: React.FC<PlateInputProps> = ({
 value,
 onChange,
 error,
 placeholder = 'ABC-1234 ou ABC1D23',
 disabled = false
}) => {
 const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
 const formatted = formatPlate(e.target.value)
 onChange(formatted)
 }

return (
    <ModernInput
      type="text"
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={disabled}
      error={error}
      maxLength={8}
      className="uppercase"
    />
  )
}

